// Services
import { AjaxService } from 'NewAngular/services/core/ajax.service';
import { UrlsService } from 'NewAngular/services/core/urls.service';
import * as i0 from "@angular/core";
import * as i1 from "NewAngular/services/core/ajax.service";
import * as i2 from "NewAngular/services/core/urls.service";
export class StressTestService {
    constructor(ajaxService, urlsService) {
        this.ajaxService = ajaxService;
        this.urlsService = urlsService;
    }
    getPDFExport(securityId, comparisonSecurityId) {
        const baseUrl = this.urlsService.getUrl(this.urlsService.STRESS_TESTS.PDF_EXPORT, { securityId });
        const url = `${baseUrl}?comparison_security_symbol=${comparisonSecurityId}`;
        return this.ajaxService.getDataObserveBody(url);
    }
    getStressTests() {
        const url = this.urlsService.STRESS_TESTS.COLLECTION;
        return this.ajaxService.getDataObserveBody(url);
    }
    getStressTestTemplates() {
        const urlParams = { templateType: 'stress_test' };
        const url = this.urlsService.getUrl(this.urlsService.DATA_TEMPLATES.DATA_TEMPLATE_LIBRARY, urlParams);
        return this.ajaxService.getDataObserveBody(url);
    }
    createStressTests(params) {
        const url = this.urlsService.STRESS_TESTS.COLLECTION;
        return this.ajaxService.postJsonDataObserveBody(url, params);
    }
    updateStressTest(params) {
        const url = this.urlsService.getUrl(this.urlsService.STRESS_TESTS.STRESS_TEST, {
            stressTestId: params.id.toString(),
        });
        return this.ajaxService.putJsonDataObserveBody(url, params);
    }
    updateStressTests(params) {
        const url = this.urlsService.STRESS_TESTS.COLLECTION;
        return this.ajaxService.putJsonDataObserveBody(url, params);
    }
    deleteStressTest(stressTestId) {
        const url = this.urlsService.getUrl(this.urlsService.STRESS_TESTS.STRESS_TEST, {
            stressTestId,
        });
        return this.ajaxService.deleteDataObserveBody(url);
    }
}
StressTestService.ɵfac = function StressTestService_Factory(__ngFactoryType__) { return new (__ngFactoryType__ || StressTestService)(i0.ɵɵinject(i1.AjaxService), i0.ɵɵinject(i2.UrlsService)); };
StressTestService.ɵprov = /*@__PURE__*/ i0.ɵɵdefineInjectable({ token: StressTestService, factory: StressTestService.ɵfac, providedIn: 'root' });
